'use client';

import React, { useState, useEffect, useMemo } from 'react';
import { Box } from '@skin-seoul/design-system';
import { getProductType, ProductStockStatus } from '@skin-seoul/service';
import TrendingProductSwiperSkeleton from './TrendingProductSwiperSkeleton';
import { Carousel, CarouselNavigation, type CarouselApi } from '@/components/ui/Carousel';
import ProductCard from '@/components/products/ProductCard/ProductCard';
import { useRegionCurrency, useReviewService, useProductService, createReviewStatsMap, getPriceProductBasicInfo } from '@skin-seoul/service';
const TrendingProductSwiper = () => {
  const {
    currency
  } = useRegionCurrency();
  const [api, setApi] = useState<CarouselApi>();
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    useGetProductsCollections
  } = useProductService();
  const {
    useGetReviewStatistics
  } = useReviewService();
  const {
    data
  } = useGetProductsCollections({
    page: 1,
    collectionName: 'About us Page Products',
    limit: 12,
    currency,
    stockStatus: ProductStockStatus.instock
  });
  const products = data?.products || [];
  const {
    data: reviewStats
  } = useGetReviewStatistics({
    productIds: products.map(product => product.productId).join(',')
  });
  const reviewStatsMap = useMemo(() => createReviewStatsMap(reviewStats), [reviewStats]);
  useEffect(() => {
    if (!api) {
      return;
    }
    const handleSelect = () => {
      setActiveIndex(api.selectedScrollSnap());
    };
    api.on('select', handleSelect);
    api.on('reInit', handleSelect);
    handleSelect();
    return () => {
      api.off('select', handleSelect);
    };
  }, [api]);
  if (products.length === 0) {
    return null;
  }
  return <Box width="100%" display={{
    base: 'none',
    tablet: 'flex'
  }} flexDirection="column" gap={12} data-sentry-element="Box" data-sentry-component="TrendingProductSwiper" data-sentry-source-file="TrendingProductSwiper.tsx">
      <Box position="relative" width="100%" overflow="hidden" data-sentry-element="Box" data-sentry-source-file="TrendingProductSwiper.tsx">
        <Carousel setApi={setApi} opts={{
        loop: true,
        align: 'start',
        skipSnaps: false
      }} w="100%" data-sentry-element="Carousel" data-sentry-source-file="TrendingProductSwiper.tsx">
          <Carousel.Content data-sentry-element="Carousel.Content" data-sentry-source-file="TrendingProductSwiper.tsx">
            {products.map(product => {
            const lowestPriceProductInfo = getPriceProductBasicInfo(product);
            const productType = getProductType(product);
            const productReviewStats = reviewStatsMap[product.productId];
            return <Carousel.Item key={product.sku} flexBasis={{
              base: '100%',
              tablet: '33.333%',
              desktop: '25%'
            }} minWidth="0" px={2} position="relative">
                  <ProductCard key={product.productId} href={product.productLink} productType={productType} name={product.name} brand={product.brand} productImage={product.productImageUrls[0]} sku={product.sku} currency={product.currency} originalPrice={lowestPriceProductInfo.originalPrice} salePrice={lowestPriceProductInfo.salePrice} rating={productReviewStats?.averageRate} reviewCount={productReviewStats?.totalReviews} productId={product.productId.toString()} category={product.category} />
                </Carousel.Item>;
          })}
          </Carousel.Content>
        </Carousel>
      </Box>

      <CarouselNavigation api={api} activeIndex={activeIndex} totalItems={Math.min(products.length, 5)} data-sentry-element="CarouselNavigation" data-sentry-source-file="TrendingProductSwiper.tsx" />
    </Box>;
};
const TrendingProductSwiperWithSkeleton = TrendingProductSwiper as typeof TrendingProductSwiper & {
  Skeleton: typeof TrendingProductSwiperSkeleton;
};
TrendingProductSwiperWithSkeleton.Skeleton = TrendingProductSwiperSkeleton;
export default TrendingProductSwiperWithSkeleton;